import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import GetAppIcon from "@mui/icons-material/GetApp";
import DownloadDialog from "./DownloadDialog";
import IconButton from "@mui/material/IconButton";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import ListItemIcon from "@mui/material/ListItemIcon";
import Tooltip from "@mui/material/Tooltip";
import Typography from "@mui/material/Typography";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import PictureAsPdfIcon from "@mui/icons-material/PictureAsPdf";
import PDFDownloadDialog from "./PDFDownloadDialog";
import { actionLayerSingleBuildingModeUpdated } from "../Layer";
import { actionAddAlert, actionDeleteAlert } from "../Alert";
import { CopyToClipboard } from "react-copy-to-clipboard";
import FileCopyIcon from "@mui/icons-material/FileCopy";

const moreBtn_ = (theme) => ({
  position: "absolute",
  top: 8,
  right: 0,
});

export default function BuildingActions({ building }) {
  const dispatch = useDispatch();

  const { bld_descrshort, bldrecnbr } = building;

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [downloadVisible, setDownloadVisible] = useState(false);
  const handleDownloadClick = () => {
    setDownloadVisible(true);
    handleClose();
  };
  const handleDownloadClose = () => {
    setDownloadVisible(false);
  };

  const quitMode = () => {
    dispatch(actionLayerSingleBuildingModeUpdated(null));
    dispatch(actionDeleteAlert("sbv"));
  };
  const singleBuildingMode = useSelector(
    (state) => state.layerReducer.singleBuildingMode,
  );
  const checked = !!singleBuildingMode && !!singleBuildingMode.bldrecnbr;

  const singleBuildingModeClickHandler = () => {
    if (checked) {
      dispatch(actionLayerSingleBuildingModeUpdated(null));
      dispatch(actionDeleteAlert("sbv"));
    } else {
      dispatch(actionLayerSingleBuildingModeUpdated(bldrecnbr));
      dispatch(
        actionAddAlert({
          id: "sbv",
          title: "Single Building View",
          buttonLabel: "QUIT",
          onClick: quitMode,
          onClose: false,
        }),
      );
    }
  };

  const [pdfDownloadVisible, setPdfDownloadVisible] = useState(false);
  const handlePdfDownloadClick = () => {
    setPdfDownloadVisible(true);
    handleClose();
  };
  const handlePdfDownloadClose = () => {
    setPdfDownloadVisible(false);
  };

  const [buildingUrlTooltip, setBuildingUrlTooltip] = useState("");
  const onCopyHandler = () => {
    setBuildingUrlTooltip("COPIED");
    setTimeout(() => {
      setBuildingUrlTooltip("");
    }, 1000);
  };

  return (
    <>
      <Tooltip title="More Options">
        <IconButton size="small" sx={moreBtn_} onClick={handleClick}>
          <MoreVertIcon />
        </IconButton>
      </Tooltip>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        <MenuItem onClick={handleDownloadClick}>
          <ListItemIcon>
            <GetAppIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">Data</Typography>
        </MenuItem>
        <MenuItem onClick={handlePdfDownloadClick}>
          <ListItemIcon>
            <PictureAsPdfIcon fontSize="small" />
          </ListItemIcon>
          <Typography variant="overline">Floor Plan</Typography>
        </MenuItem>
        <Tooltip describeChild title={buildingUrlTooltip}>
          <span>
            <CopyToClipboard
              text={`${window.location.href}#feature=search&brn=${bldrecnbr}`}
              onCopy={onCopyHandler}
            >
              <MenuItem>
                <ListItemIcon>
                  <FileCopyIcon fontSize="small" />
                </ListItemIcon>
                <Typography variant="overline">Building URL</Typography>
              </MenuItem>
            </CopyToClipboard>
          </span>
        </Tooltip>
        <MenuItem onClick={singleBuildingModeClickHandler}>
          <ListItemIcon>
            {checked ? (
              <CheckBoxIcon fontSize="small" />
            ) : (
              <CheckBoxOutlineBlankIcon fontSize="small" />
            )}
          </ListItemIcon>
          <Typography variant="overline">Single Building</Typography>
        </MenuItem>
      </Menu>
      <DownloadDialog
        open={downloadVisible}
        onClose={handleDownloadClose}
        bldrecnbr={bldrecnbr}
        name={bld_descrshort}
      />
      <PDFDownloadDialog
        open={pdfDownloadVisible}
        onClose={handlePdfDownloadClose}
        bldrecnbr={bldrecnbr}
        name={bld_descrshort}
      />
    </>
  );
}
